<template>
  <div class="image-container">
    <div class="ao__aside">
      <NuxtImg
        v-if="props.src && !imageNotFound"
        loading="lazy"
        class="object-cover h-full w-full"
        :src="String(props.src)"
        :alt="props.alt || ''"
        :width="props.width"
        :height="props.height"
        :sizes="props.sizes"
        @error="onError"
      />
      <img
        v-else
        class="object-cover h-full w-full"
        loading="lazy"
        :src="getNotFoundImage()"
        :alt="props.alt || ''"
        width="800"
        height="450"
      />
    </div>
    <div v-if="props.caption || props.source" class="image-container__caption">
      <span v-if="props.caption" class="image-container__title">{{ props.caption }}</span>
      <span v-if="props.caption && props.source" class="image-container__divider" />
      <span v-if="props.source" class="image-container__source">{{ $t('artobjects.source') }}: {{ props.source }}</span>
    </div>
  </div>

</template>

<script setup lang="ts">
import type {Maybe} from "@graphql-tools/utils"

import defaultNotFound from 'assets/images/default/not-found.png'
import poggersNotFound from 'assets/images/poggers/not-found.png'
import materidouskaNotFound from 'assets/images/materidouska/not-found.png'
import heyfomoNotFound from 'assets/images/heyfomo/not-found.png'

import {useUniWebTemplate} from "~/composables/useUniWebTemplate";
import {TemplateList} from "~/libs/constants/TemplateList";

const props = withDefaults(defineProps<{
  src?: Maybe<string>,
  source?: Maybe<string>,
  caption?: Maybe<string>,
  alt?: Maybe<string>,
  width?: number,
  height?: number,
  sizes?: string,
}>(), {
  width: 680,
  height: 383,
  sizes: 'sm:100vw lg:680px',
})

const template = useUniWebTemplate()
const imageNotFound = ref(false)

const getNotFoundImage = () => {
  switch (template.uniWebTemplateNameLowerCase) {
    case TemplateList.MATERIDOUSKA:
      return materidouskaNotFound
    case TemplateList.POGGERS:
      return poggersNotFound
    case TemplateList.HEYFOMO:
      return heyfomoNotFound
    default:
      return defaultNotFound
  }
}

const onError = (e) => {
  imageNotFound.value = true
}
</script>
